import { Injectable } from "@angular/core";
import { ApiEsService } from "./api-es.service";
import { ArgsDownloadFileEs } from "@edp-models/ES/es-file.model";

@Injectable({
    providedIn: "root",
})
export class FileEsService {
    constructor(private apiEsService: ApiEsService) {}

    public getFile(args: any) {
        return this.apiEsService.callServicePostToCollection("solar.services.file.getFiles", args, null, false);
    }

    public getDocuments(args: any) {
        return this.apiEsService.callServicePostToCollection("solar.services.file.getDocuments", args, null, false);
    }

    public downloadFile(args: ArgsDownloadFileEs) {
        return this.apiEsService.callServicePostToCollection("solar.services.file.downloadFile", args, null, false);
    }
}
